export default {
  "modules.global.add.cart": "TOVOEGEN AAN WINKELMANDJE", // 加车
  "modules.global.previous": "VORIGE", // 上一步
  "modules.global.next": "VOLGENDE", // 下一步
  "modules.global.continue": "BLIJVEN", // 继续
  "modules.global.confirm": "BEVESTIGEN", // 确认
  "modules.global.free": "GRATIS", // 免费

  "modules.global.delete.tips": "Weet u zeker dat u dit wilt verwijderen?", // 删除提示
  "modules.global.delete": "verwijder", // 删除
  "modules.global.cancel": "Annuleer", // 取消
  "modules.global.done": "Gedaan", // 完成
  "modules.global.order": "Bestel", // 结算
  "modules.global.recommend": "Beveel  aan.", // 推荐
  "modules.global.change": "Verander", // 更换
  "modules.global.cropper": "Gewas", // 裁剪
  "modules.global.cropper.image": "Cropper Beeld", // 裁剪图片
  "modules.global.checkout": "kassa", // 结账
  "modules.global.replace": "vervangen", // 替换
  "modules.global.complete": "compleet", // 完成
  "modules.global.revoke": "Herroeping", // 撤销
  "modules.global.warning.title": "waarschuwing", // 警告

  "modules.global.ai.crop.complete": "Ja! Compleet!", // 切图完成
  "modules.global.ai.croping.photo": "AI Croping uw foto", // ai切图中

  "modules.error.load.font":
    "Fout bij het laden van het lettertype, probeer het opnieuw", // 字体加载失败 请重试
  "modules.error.load.photo":
    "Fout bij het laden van de foto's, probeer het nog eens", // 图片加载失败 请重试
  "modules.error.upload.result": "Upload error. Probeer het opnieuw", // 上传失败 请重试

  // zuploader
  "plugin.zuploader.from.album": "Kies uit uw album", // 从相册中选择
  "plugin.zuploader.from.camera": "Neem een foto", // 拍照
  "plugin.zuploader.from.social": "Kies uit de online diensten", // 从在线服务中选择
  "plugin.zuploader.wait.upload": "Wachten op de upload", // 等待上传
  "plugin.zuploader.choose.source": "Kies foto's", // 选择照片来源
  "plugin.zuploader.choose.image.title": "Foto's geüpload", // 已上传照片
  "plugin.zuploader.choose.image.choose": "Selecteer foto's", // 选择照片
  "plugin.zuploader.choose.image.range": "Selecteer $value foto's", // 选择 $value 照片

  // 增值产品-relatedProduct
  "increment.related.product.title":
    "Kies een super verrassingspakket voor uw cadeau", // 选择超惊喜套餐作为礼物
  "increment.related.product.no.thanks": "Nee, bedankt.", // 不用，谢谢

  // 增值产品-vip
  "increment.vip.tip":
    "De beste keuze voor het verwerken van bestellingen met prioriteit produceren & verzenden", // 优先生产和运输订单的最佳选择
  "increment.vip.service": "VIP-SERVICE", // vip 服务

  // Spotify Code
  "modules.spotify.code.search.hot": "Hot zoeken", // 热门搜索
  "modules.spotify.code.search.reuslt": "Zoekresultaten", // 搜索结果
  "modules.spotify.code.placeholder": "Zoek nummer,Kunstenaar,Album", // 输入你的歌曲
  "modules.spotify.code.album.upload": "Upload uw foto", // 上传你的图片
  "modules.spotify.code.album.track": "Gebruik de albumomslag", // 使用相册封面
  "modules.spotify.code.change.color": "Kies uw kleur", // 选择你的颜色
  "modules.spotify.code.custom.artists": "Kies uw kleur", // 你可以自己定制演奏者

  // 新袜子
  "modules.new.sock.network.error": "Netwerkfout!", // 网络错误
  "modules.new.sock.ai.crop.error": "AI Crop Error!", // 切图服务错误
  "modules.new.sock.replace.photo": "Vervang de foto", // 替换照片
  "modules.new.sock.crop.myself": "Crop by myself", // 自己切图
  "modules.new.sock.try.again": "Probeer het nog eens", // 重试
  "modules.new.sock.edit.avatar": "Bewerk Avatar", // 编辑头像
  "modules.new.sock.add.line.text.title": "Tekst toevoegen?", // 是否需要刻字
  "modules.new.sock.add.line.text.promotion":
    "80% van de klanten geeft de voorkeur aan het toevoegen van gepersonaliseerde tekst om een perfect geschenk te maken!", // 80％的客户更喜欢添加个性化文字来制作精美的礼物！
  "modules.new.sock.add.line.text": "TEKST TOEVOEGEN", // 添加文字
  "modules.new.sock.without.text": "ZONDER TEKST", // 不刻字
  "modules.new.sock.color": "KLEUR", // 颜色
  "modules.new.sock.size": "MAAT", // 尺寸
  "modules.new.sock.sock": "SOKKEN", // 袜子
  "modules.new.sock.sort": "Soort", // 确认

  "modules.new.sock.share.title": "Delen om te krijgen", // 分享后你将会得到
  "modules.new.sock.social.avatar": "Aangepaste Sociale Profiel Foto.", // 你的社交新头像
  "modules.new.sock.free.download": "Gratis download", // 免费下载
  "modules.new.sock.new.mobile.wallpaper": "Mobiel behang op maat.", // 你的手机新壁纸
  "modules.new.sock.new.pc.wallpaper": "Aangepast PC-behang.", // 你的电脑新壁纸
  "modules.new.sock.discount": "Korting", // 折扣
  "modules.new.sock.discount.price": "$value UIT", // 立减 $value 块
  "modules.new.sock.share.now": "NU DELEN", // 立刻分享
  "modules.new.sock.no.thanks": "NEE, DANKT", // 不分享
  "modules.new.sock.shared.title": "GEFELICITEERD!", // 恭喜
  "modules.new.sock.download": "Download", // 下载
  "modules.new.sock.generating.image": "Het genereren van een aandelenimago", // 正在生成分享图
  "modules.new.sock.total": "totaal", // 总计
  "modules.new.sock.upload.error": "Uploadfout. Probeer het opnieuw", // 上传失败，请重试
  "modules.new.sock.your.text": "text", // 文字
};
